import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  GroupMutedConversations,
  GroupResults,
} from "../../../model/chats/GroupConversationDetailsModel";
import { DepartmentMutedConversations } from "../../../model/chats/DepartmentConversationDetailsModel";
import { TeamMutedConversations } from "../../../model/chats/TeamConversationDetailsModel";
import { ForwardMessageList } from "../../../model/chats/ForwardProfileListModel";
import { MediaForwardList } from "../../../model/chats/ChatMediaModel";

interface ChatsInterface {
  timeStamp: number;
  chatRefreshListStatus: boolean;
  chatClearResetChatDetail: boolean;
  /* conversationDetailTeam: TeamResults | null;
  conversationDetailDepartment: DepartmentResults | null;*/
  conversationDetailGroup: GroupResults | null;

  muteSettingsTeam: TeamMutedConversations | null;
  muteDurationTeam: string;

  muteSettingsDepartment: DepartmentMutedConversations | null;
  muteDurationDepartment: string;

  muteSettingsGroup: GroupMutedConversations | null;
  muteDurationGroup: string;

  sendMessageDetail: SendMessageDetailType | null;

  cancelARFDetail: CancelARFDetailType | null;

  messageDeleteEveryone: MessageDeleteEveryoneType | null;
  messageDeleteActionType: "0" | "1" | null;

  mediaDeleteEveryone: MediaDeleteEveryoneType | null;
  mediaDeleteActionType: "0" | "1" | null;

  forwardedMessages: Array<ForwardMessageList> | null;
  forwardedMediaList: Array<MediaForwardList> | null;
}

type CancelARFDetailType = {
  groupId: string;
};

type MessageDeleteEveryoneType = {
  isEveryone: boolean;
  flag: string;
};

type MediaDeleteEveryoneType = {
  isEveryone: boolean;
  messagesId: Array<string>;
  flag: string;
};

type SendMessageDetailType = {
  messageType: string;
  message: string;
};

const initialState: ChatsInterface = {
  timeStamp: Date.now(),
  chatRefreshListStatus: false,
  chatClearResetChatDetail: false,
  /*  conversationDetailTeam: null,
  conversationDetailDepartment: null, */
  conversationDetailGroup: null,

  muteSettingsTeam: null,
  muteDurationTeam: "",

  muteSettingsDepartment: null,
  muteDurationDepartment: "",

  muteSettingsGroup: null,
  muteDurationGroup: "",

  sendMessageDetail: null,

  cancelARFDetail: null,

  messageDeleteEveryone: null,
  messageDeleteActionType: null,

  mediaDeleteEveryone: null,
  mediaDeleteActionType: null,

  forwardedMessages: null,
  forwardedMediaList: null,
};

const chatsSlice = createSlice({
  name: "chats",
  initialState,
  reducers: {
    chatResfreshTimeStamp: (state) => {
      state.timeStamp = Date.now();
    },
    chatRefreshListStatus: (state, action: PayloadAction<boolean>) => {
      state.chatRefreshListStatus = action.payload;
    },

    clearResetSelectedChat: (state, action: PayloadAction<boolean>) => {
      state.chatClearResetChatDetail = action.payload;
    },

    sendChatMessage: (
      state,
      action: PayloadAction<SendMessageDetailType | null>
    ) => {
      state.sendMessageDetail = action.payload;
    },

    messageDeleteEveryoneAction: (
      state,
      action: PayloadAction<MessageDeleteEveryoneType>
    ) => {
      state.messageDeleteEveryone = action.payload;
    },

    messageDeleteChooseAction: (
      state,
      action: PayloadAction<"0" | "1" | null>
    ) => {
      state.messageDeleteActionType = action.payload;
    },

    mediaDeleteEveryoneAction: (
      state,
      action: PayloadAction<MediaDeleteEveryoneType>
    ) => {
      state.mediaDeleteEveryone = action.payload;
    },

    mediaDeleteChooseAction: (
      state,
      action: PayloadAction<"0" | "1" | null>
    ) => {
      state.mediaDeleteActionType = action.payload;
    },

    setForwardMediaList: (
      state,
      action: PayloadAction<Array<MediaForwardList> | null>
    ) => {
      state.forwardedMediaList = action.payload;
    },

    sendForwardMessages: (
      state,
      action: PayloadAction<Array<ForwardMessageList> | null>
    ) => {
      state.forwardedMessages = action.payload;
    },

    /* updateTeamConversationDetail: (
      state,
      action: PayloadAction<TeamResults | null>
    ) => {
      state.conversationDetailTeam = action.payload;
    },
    updateDepartmentConversationDetail: (
      state,
      action: PayloadAction<DepartmentResults | null>
    ) => {
      state.conversationDetailDepartment = action.payload;
    }, */

    updateGroupConversationDetail: (
      state,
      action: PayloadAction<GroupResults | null>
    ) => {
      state.conversationDetailGroup = action.payload;
    },

    // TEAM
    updateTeamMuteSettings: (
      state,
      action: PayloadAction<TeamMutedConversations | null>
    ) => {
      state.muteSettingsTeam = action.payload;
    },
    changeTeamMuteDuration: (state, action: PayloadAction<string>) => {
      state.muteDurationTeam = action.payload;
    },

    // DEPARTMENT
    updateDepartmentMuteSettings: (
      state,
      action: PayloadAction<DepartmentMutedConversations | null>
    ) => {
      state.muteSettingsDepartment = action.payload;
    },
    changeDepartmentMuteDuration: (state, action: PayloadAction<string>) => {
      state.muteDurationDepartment = action.payload;
    },

    // GROUP
    updateGroupMuteSettings: (
      state,
      action: PayloadAction<GroupMutedConversations | null>
    ) => {
      state.muteSettingsGroup = action.payload;
    },
    changeGroupMuteDuration: (state, action: PayloadAction<string>) => {
      state.muteDurationGroup = action.payload;
    },
    cancelChatARF: (
      state,
      action: PayloadAction<CancelARFDetailType | null>
    ) => {
      state.cancelARFDetail = action.payload;
    },
  },
});

export const {
  chatResfreshTimeStamp,
  chatRefreshListStatus,
  clearResetSelectedChat,
  /*  updateTeamConversationDetail,
  updateDepartmentConversationDetail, */
  updateGroupConversationDetail,

  updateTeamMuteSettings,
  changeTeamMuteDuration,

  updateDepartmentMuteSettings,
  changeDepartmentMuteDuration,

  updateGroupMuteSettings,
  changeGroupMuteDuration,

  sendChatMessage,
  cancelChatARF,

  messageDeleteEveryoneAction,
  messageDeleteChooseAction,

  mediaDeleteEveryoneAction,
  mediaDeleteChooseAction,

  sendForwardMessages,
  setForwardMediaList,
} = chatsSlice.actions;

export default chatsSlice.reducer;
